import { useState, useEffect } from 'react';
import App from './App';
import UpdatePrompt from './components/UpdatePrompt';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { GuidedTourProvider } from './contexts/GuidedTourContext';

const AppWrapper = () => {
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorkerRegistration | null>(null);

  useEffect(() => {
    // Register service worker with update callback
    serviceWorkerRegistration.register({
      onUpdate: (registration) => {
        console.log('New version available!');
        setWaitingWorker(registration);
      },
      onSuccess: () => {
        console.log('App is cached for offline use.');
      },
    });

    // Also check for updates periodically (every 5 minutes)
    const checkForUpdates = () => {
      if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.update().catch((err) => {
            console.log('Error checking for service worker update:', err);
          });
        });
      }
    };

    const intervalId = setInterval(checkForUpdates, 5 * 60 * 1000);

    // Listen for controller change (when new SW takes over)
    const handleControllerChange = () => {
      // Reload once when the new service worker takes control
      window.location.reload();
    };

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);
    }

    return () => {
      clearInterval(intervalId);
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
      }
    };
  }, []);

  return (
    <GuidedTourProvider>
      <App />
      <UpdatePrompt registration={waitingWorker} />
    </GuidedTourProvider>
  );
};

export default AppWrapper;
